import { ITraining } from '../common/data/dtos/training';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';
import { IPermission } from '../common/data/dtos/permission';

const BASE_PATH = 'api/Training';

interface TrainingResponse {
    success: boolean;
    training?: ITraining;
    trainings?: ITraining[];
    error?: string;
}

type CreateTrainingType = Omit<ITraining, 'id'> | Partial<ITraining>;

const createTraining = async (training: CreateTrainingType): Promise<TrainingResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ITraining>(`${BASE_PATH}`, training);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteTraining = async (id: string): Promise<TrainingResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ITraining>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateTraining = async (training: ITraining): Promise<TrainingResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ITraining>(`${BASE_PATH}/${training.id}`, training);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getTrainings = async (): Promise<TrainingResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITraining>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainings: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneTraining = async (id: string): Promise<TrainingResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITraining>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, training: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createTraining,
    deleteTraining,
    updateTraining,
    getTrainings,
    getOneTraining,
};
